import React from 'react';

import { components, DropdownIndicatorProps } from 'react-select';

import { SearchIcon } from 'assets/images';
import { OptionType } from 'utils/inputSelect';

import styles from './DropdownIndicator.module.scss';

const DropdownIndicator = (props: DropdownIndicatorProps<OptionType>) => {
  return (
    <components.DropdownIndicator {...props}>
      <SearchIcon className={styles.searchIcon} />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
